// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__GjtTF","select":"Header_select__1l8GI","clinic":"Header_clinic__2LvXz"};